import cn from 'classnames';
import { ReactNode } from 'react';

interface ArticlePremiumContentWrapperProps {
  className?: string;
  contentCover?: ReactNode;
  children: JSX.Element;
}
export default function ArticleHiddenContentWrapper({
  className,
  contentCover,
  children,
}: ArticlePremiumContentWrapperProps) {
  return (
    <div className={cn('relative', className)}>
      {contentCover}
      <div className="pointer-events-none fade-out-gradient select-none">
        <div className='h-24 overflow-hidden'>
          {children}
        </div>
      </div>
    </div>
  );
}
